import { useEffect, useState } from 'react';
import { patientPortal } from '@/api/patientPortal';
import PatientPortalPageHero from './PatientPortalPageHero';

type Notif = { id: string; title: string; body: string; readAt: string | null; createdAt: string };

export default function PatientPortalNotifications() {
  const [rows, setRows] = useState<Notif[]>([]);

  const load = () => patientPortal.getNotifications().then(setRows);

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="space-y-6">
      <PatientPortalPageHero
        imageKey="notifications"
        eyebrow="Inbox"
        title="Notifications"
        subtitle="Reminders, loyalty updates, and messages from your care team"
        compact
      />
      <ul className="space-y-3">
        {rows.map((n) => (
          <li key={n.id}>
            <button
              type="button"
              className={`w-full text-left border rounded-lg p-4 bg-white hover:border-teal-500 ${
                !n.readAt ? 'border-l-4 border-l-teal-600' : ''
              }`}
              onClick={() => patientPortal.markNotificationRead(n.id).then(load)}
            >
              <p className="font-semibold">{n.title}</p>
              <p className="text-sm text-muted-foreground mt-1">{n.body}</p>
              <p className="text-xs text-muted-foreground mt-2">
                {new Date(n.createdAt).toLocaleString()}
              </p>
            </button>
          </li>
        ))}
      </ul>
      {rows.length === 0 && <p className="text-muted-foreground">No notifications yet.</p>}
    </div>
  );
}
